import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import AuthWrapper from './components/auth/AuthWrapper';
import './App.css';

// Components
import BottomNav from './components/BottomNav';
import MapView from './components/MapView';
import ChatList from './components/ChatList';
import EventsList from './components/EventsList';
import Profile from './components/Profile';
import CheckIns from './components/CheckIns';
import Discovery from './components/Discovery';
import ChatRoom from './components/ChatRoom';

// Dummy Data
const dummyUsers = [
  {
    id: 1,
    name: "Alex Chen",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    location: { lat: 37.7749, lng: -122.4194 },
    status: "Working from cafe",
    skills: ["React", "Node.js", "Design"],
    isOnline: true,
    distance: "0.2km"
  },
  {
    id: 2,
    name: "Maria Santos",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b515?w=150&h=150&fit=crop&crop=face",
    location: { lat: 37.7849, lng: -122.4094 },
    status: "Available for collab",
    skills: ["Python", "AI", "Data Science"],
    isOnline: true,
    distance: "0.8km"
  },
  {
    id: 3,
    name: "Jake Miller",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    location: { lat: 37.7649, lng: -122.4394 },
    status: "Taking a break",
    skills: ["Marketing", "Content", "Strategy"],
    isOnline: false,
    distance: "1.2km"
  }
];

const dummyEvents = [
  {
    id: 1,
    title: "Coffee & Code Morning",
    location: "Blue Bottle Coffee",
    time: "9:00 AM Today",
    attendees: 8,
    type: "casual",
    organizer: "Alex Chen",
    description: "Join us for morning coffee and casual coding"
  },
  {
    id: 2,
    title: "Startup Pitch Night",
    location: "WeWork SOMA",
    time: "6:00 PM Tomorrow",
    attendees: 24,
    type: "professional",
    organizer: "Maria Santos",
    description: "Present your startup ideas to fellow nomads"
  }
];

const dummyChats = [
  {
    id: 1,
    name: "Alex Chen",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    lastMessage: "Hey, want to grab coffee later?",
    time: "2m ago",
    unread: 2,
    isOnline: true
  },
  {
    id: 2,
    name: "SF Nomads Group",
    avatar: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=150&h=150&fit=crop",
    lastMessage: "Anyone up for coworking tomorrow?",
    time: "15m ago",
    unread: 0,
    isGroup: true
  }
];

const dummyCheckIns = [
  {
    id: 1,
    location: "Philz Coffee Mission",
    time: "2 hours ago",
    image: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=400&h=300&fit=crop",
    likes: 12,
    comments: 3
  },
  {
    id: 2,
    location: "Golden Gate Park",
    time: "Yesterday",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop",
    likes: 28,
    comments: 7
  }
];

const MainApp = () => {
  const [currentUser, setCurrentUser] = useState({
    id: 0,
    name: "You",
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop&crop=face",
    location: { lat: 37.7749, lng: -122.4194 },
    status: "Exploring the city",
    skills: ["Full Stack", "UI/UX", "Mobile"]
  });

  const [users, setUsers] = useState(dummyUsers);
  const [events, setEvents] = useState(dummyEvents);
  const [chats, setChats] = useState(dummyChats);
  const [checkIns, setCheckIns] = useState(dummyCheckIns);

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Navigate to="/map" replace />} />
          <Route 
            path="/map" 
            element={
              <MapView 
                users={users} 
                currentUser={currentUser}
                events={events}
              />
            } 
          />
          <Route 
            path="/discovery" 
            element={
              <Discovery 
                users={users} 
                currentUser={currentUser}
              />
            } 
          />
          <Route 
            path="/chat" 
            element={<ChatList chats={chats} />} 
          />
          <Route 
            path="/chat/:chatId" 
            element={<ChatRoom />} 
          />
          <Route 
            path="/events" 
            element={<EventsList events={events} />} 
          />
          <Route 
            path="/checkins" 
            element={<CheckIns checkIns={checkIns} currentUser={currentUser} />} 
          />
          <Route 
            path="/profile" 
            element={<Profile user={currentUser} setUser={setCurrentUser} />} 
          />
        </Routes>
        
        <BottomNav />
      </div>
    </Router>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <AuthWrapper>
            <MainApp />
          </AuthWrapper>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;